import Footer from "../../footer"
import NavBar from "../../nav"

const Training = () => {
  return <div className='training'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Training Manuals</h1>
				<div className="headline-divider sections"></div>
				<h2>Modular Training Programs &amp; Curriculum</h2>
				<h3>Training that matches the guidance.</h3>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container about-container">	
				<div className="prose">Fly Compliant, LLC for twenty-years has produced a modular training program assisting part 135 of all sizes to have a standardized training curriculum across all types. We are continually revising the training program as the guidance continues to evolve.</div>
				<div className="prose not-first">With the new standardized curriculum each aircraft type will be considered an appendix of our general training program.<br />Reference: AC 142-1.</div>
				<div className="prose not-first">For more information regarding our Training Manuals, <a href="/contact-us">contact our team</a>.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default Training